
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { VPopover } from 'v-tooltip'

@Component<BaseTooltip>({
    components: {
        VPopover,
    },
})
export default class BaseTooltip extends Vue {}
